module.exports = __webpack_public_path__ + "static/img/yytx12.ccc28a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx12.png
// module id = 792
// module chunks = 0